import { AlertPort, DownloaderPort, ProCheckPorts } from './ports'
import UserDataStore from 'iam/UserDataStore'
import { GetCurrentUser } from 'iam/SessionStore'
import { UserDataType } from 'iam/models/UserDataType'
import { AlertFactory } from 'alerts/Alert'
import { StreamDownloader } from 'infra/StreamDownloader'

export class ProPayoutsModuleAdapter
  implements AlertPort, DownloaderPort, ProCheckPorts
{
  constructor(
    public readonly newAlert: AlertFactory,
    public readonly downloader: StreamDownloader,
    private readonly getCurrentUser: GetCurrentUser,
    private readonly userDataStore: UserDataStore
  ) {}

  async currentUserIsPro(): Promise<boolean> {
    return await this.userDataStore
      .fetchByPublicId(this.getCurrentUser().publicId)
      .then((d) => d.userDataType === UserDataType.Pro)
  }
}
